var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[_c('CommonFlame',{attrs:{"title":`${_vm.name} ${_vm.title}`}},[_c('div',{staticClass:"wrap mt-1"},_vm._l((_vm.featureList(_vm.id)),function(feature){return _c('a',{key:feature.id,staticClass:"ma-5",on:{"click":function($event){return _vm.$router.push({
						name: feature.name,
						params: { id: _vm.id, department_id: _vm.id },
					})}}},[_vm._v("\n\t\t\t\t"+_vm._s(feature.title)+"\n\t\t\t")])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }